// Type
export const GET_USER_PERMISSION = `GET_USER_PERMISSION`;
export const GET_USER_INFO_DETAIL = `GET_USER_INFO_DETAIL`;

// Action
export const getPermissionUser = (data) => async dispatch => {
    await dispatch({
        type: GET_USER_PERMISSION,
        data: data
    })
}

export const getUserInfoDetail = (data) => async dispatch => {
    await dispatch({
        type: GET_USER_INFO_DETAIL,
        data: data
    })
}

// Reducer
const initState = {
    permissionArr: [],
    userInfoDetail: {},
}

const UserGetReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_USER_PERMISSION:
            return {
                ...state,
                permissionArr: action.data || []
            }
        case GET_USER_INFO_DETAIL:
            return {
                ...state,
                userInfoDetail: action.data || {}
            }
        default: return state;
    }
}
export default UserGetReducer;